import React from 'react';
import {useNavigate} from "react-router-dom";
import getMediaUrl, { getDefaultProductImage } from "../../../components/tools/utils.jsx";

const CardProduct = ({ product, isAdmin, onEdit, onDelete }) => {


    const navigate = useNavigate();
    const imgSrc = getDefaultProductImage(product);
    return (
        <div className="rounded-xl " onClick={() => navigate(`/product/${product.id}`)}>
            <figure className="">
                {imgSrc ? (
                    <img
                        src={getMediaUrl(imgSrc)}
                        alt={product.name}
                        className="h-48 w-full object-cover rounded-xl"
                    />
                ) : (
                    <div className="h-48 w-full flex items-center justify-center bg-gray-200 text-gray-500 dark:text-white ">
                        No hay imágenes disponibles
                    </div>
                )}

            </figure>
        </div>
    );
};

export default CardProduct;
